import React, { useEffect, useState } from 'react'
import 'firebase/performance'
import 'firebase/firestore'
import { Meter, Box, Stack, Text } from 'grommet'

import { emptyScoresArray } from '../../utils/emptyProperty'
import { prettyTitle } from '../../utils/utils'
import { isRange, sumNumbersInArray } from '../../utils/propertyComponents'
import { firebaseApp } from '../Firebase/FirebaseApp'

function GetScores(props) {
  const [compare, setCompare] = useState(emptyScoresArray)

  useEffect(() => {
    // we don't want to setState multiple times so we work with an object
    // to then do it altogether at the end.
    let scoreObject = { ...emptyScoresArray }
    if (props.property === '') return

    const fetchCompare = async () => {
      const firestore = await firebaseApp.firestore()
      const docData = []
      if (!firestore) {
        return null
      } else {
        const usersRef = await firestore
          .collection('admin')
          .doc('users')
          .get()
          .then((doc) => doc.exists && doc.data())

        const promises = usersRef.userIDs.map(async (userID) => {
          await firestore
            .collection(userID)
            .doc(props.property)
            .get()
            .then((doc) => {
              // boolean check before action
              if (doc.exists) {
                docData.push({ [userID]: doc.data() })
              }
            })
            .catch((error) => {
              // eslint-disable-next-line no-console
              console.error('Error getting document:', error)
            })
        })
        Promise.all(promises).then(() => {
          if (docData !== undefined && docData.length !== 0) {
            docData.forEach((user) => {
              const userData = Object.values(user)[0]
              const userScores = Object.keys(userData)
              userScores.forEach((score) => {
                if (isRange(score) && Array.isArray(scoreObject[score])) {
                  scoreObject[score].push(userData[score])
                }
              })
            })

            const scoreObjectKeys = Object.keys(scoreObject)

            for (const key of scoreObjectKeys) {
              if (!Array.isArray(scoreObject[key])) return null
              const totalScore = sumNumbersInArray(scoreObject[key])
              const averageScore = Math.round(
                totalScore / (scoreObject[key].length === 0 ? 1 : scoreObject[key].length)
              )
              scoreObject[key] = averageScore
            }
            setCompare(scoreObject)
          }
        })
      }
    }

    fetchCompare()

    return function cleanup() {
      setCompare(emptyScoresArray)
    }
  }, [props.property])

  return (
    <ul>
      {Object.keys(compare).map((key) => {
        const label = prettyTitle(key)
        const meterValue = typeof compare[key] === 'number' ? compare[key] : 0
        const getBgColor = () => {
          // function that returns a grommet predefined color. We could also set
          // the opacity or work with HEX/rgb/rgba. This works for now.
          if (meterValue < 25) {
            return 'status-critical'
          } else if (meterValue >= 25 && meterValue < 50) {
            return 'status-warning'
          } else if (meterValue >= 50 && meterValue < 60) {
            return 'accent-4'
          } else if (meterValue >= 60 && meterValue < 70) {
            return 'accent-4'
          } else if (meterValue >= 70 && meterValue < 85) {
            return 'accent-1'
          } else {
            return 'status-ok'
          }
        }
        const backgroundColor = getBgColor()
        return (
          <li key={key}>
            {label}: <br />
            <Stack anchor="center">
              <Meter
                type="bar"
                values={[
                  {
                    value: meterValue,
                    label: label,
                    max: 100,
                    color: backgroundColor
                  }
                ]}
                thickness="medium"
              />
              <Box direction="row" align="center" pad={{ bottom: 'small' }}>
                <Text size="small" weight="bold">
                  {meterValue}
                </Text>
                <Text size="small">%</Text>
              </Box>
            </Stack>
          </li>
        )
      })}
    </ul>
  )
}

export default GetScores
